import { useEffect, useState } from "react";
import { Spinner } from "@/components/shared/spinner";

// Delays the spinner so fast/cached chunks don't flash it during navigation.
export function RouteFallback({ minHeight = "50vh" }: { minHeight?: string }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(t);
  }, []);
  if (!show) return null;
  return (
    <div className="flex w-full items-center justify-center" style={{ minHeight }}>
      <Spinner color="foreground" className="size-8" />
    </div>
  );
}
